__turbopack_context__.v({
  "allFooter": "NlXj_q_allFooter",
  "footer": "NlXj_q_footer",
  "logo": "NlXj_q_logo",
  "page-body-wrap": "NlXj_q_page-body-wrap",
  "paragraph-content": "NlXj_q_paragraph-content",
  "text": "NlXj_q_text",
  "textMedsos": "NlXj_q_textMedsos",
  "wrap-container": "NlXj_q_wrap-container",
  "wrap-content": "NlXj_q_wrap-content",
});
